<template>
  <generic-modal
    size
    :title="$t('import project')"
    icon="cloud upload"
    image="/images/icons/project.jpg"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <file-pond
        name="file"
        ref="pond"
        :label-idle="$t('click or drop files here')"
        v-bind:allow-multiple="false"
        v-bind:allow-revert="false"
        v-bind:server="{
          url: api_host,
          timeout: enterprise_setup.upload_timeout,
          process: {
            url: '/ngine_composer/project/do-upload-import',
            method: 'POST',
            headers: {
              'x-access-token': token_session,
            },
            withCredentials: false,
          },
        }"
        v-on:error="filepond_error"
        v-on:processfile="filepond_process"
      />
      <div class="ui fluid card" v-if="import_summary">
        <div class="content">
          <div class="ui items">
            <div class="ui item">
              <a class="ui tiny image">
                <img src="/images/icons/summary.png" />
              </a>
              <div class="content">
                <a class="header">{{ import_summary.name }}</a>
                <div class="description">
                  <p>{{ import_summary.description }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="extra">
            <div class="ui grid">
              <div class="eight wide column">
                <h5 class="ui dividing header">
                  {{ $t("processes") }} ({{
                    import_summary.setup.processes.length
                  }})
                </h5>
                <div class="ui relaxed divided list">
                  <div
                    class="item"
                    v-for="(proc, index) in import_summary.setup.processes"
                    :key="index"
                  >
                    <i class="large settings middle aligned icon"></i>
                    <div class="content">
                      <a class="header">{{ proc.name }}</a>
                      <div class="description">{{ proc.description }}</div>
                    </div>
                  </div>
                </div>
                <h5 class="ui dividing header">
                  {{ $t("human tasks") }} ({{
                    import_summary.setup.human_tasks.length
                  }})
                </h5>
                <div class="ui relaxed divided list">
                  <div
                    class="item"
                    v-for="(proc, index) in import_summary.setup.human_tasks"
                    :key="index"
                  >
                    <i class="large user middle aligned icon"></i>
                    <div class="content">
                      <a class="header">{{ proc.name }}</a>
                      <div class="description">{{ proc.description }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="eight wide column">
                <h5 class="ui dividing header">
                  {{ $t("business objects") }} ({{
                    import_summary.setup.business_objects.length
                  }})
                </h5>
                <div class="ui relaxed divided list">
                  <div
                    class="item"
                    v-for="(proc, index) in import_summary.setup
                      .business_objects"
                    :key="index"
                  >
                    <i class="large cube middle aligned icon"></i>
                    <div class="content">
                      <a class="header">{{ proc.name }}</a>
                      <div class="description">{{ proc.description }}</div>
                    </div>
                  </div>
                </div>
                <h5 class="ui dividing header">
                  {{ $t("variables") }} ({{
                    import_summary.setup.variables.length
                  }})
                </h5>
                <div class="ui relaxed divided list">
                  <div
                    class="item"
                    v-for="(proc, index) in import_summary.setup.variables"
                    :key="index"
                  >
                    <i class="large chess middle aligned icon"></i>
                    <div class="content">
                      <a class="header">{{ proc }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, enterprise_setup, error_toast, api_host } from "@/utils";
import GenericModal from "@/components/GenericModal";
import vueFilePond from "vue-filepond";

const FilePond = vueFilePond();

export default {
  name: "ProjectImportModal",
  components: {
    "generic-modal": GenericModal,
    FilePond,
  },
  computed: {
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  props: { project: Object },
  data() {
    return {
      import_summary: undefined,
      api_host: api_host,
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          local_api(
            vm,
            "post",
            "/ngine_composer/project/do-import",
            vm.import_summary,
          )
            .then((project) => {
              vm.$emit("succedded", project);
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      // this.$destroy();
    },
    filepond_error(err) {
      error_toast(err);
      this.resumed_vars = undefined;
    },
    filepond_process(event, inst) {
      if (inst.serverId) {
        let r = JSON.parse(inst.serverId);
        if (!r.success) console.log(r.error);
        else {
          try {
            let resumed_vars = [];
            if (r.data.setup.variables) {
              resumed_vars = [
                ...new Set(r.data.setup.variables.map((v) => v.name)),
              ];
            }

            r.data.setup.variables = resumed_vars;

            this.import_summary = r.data;
          } catch (error) {
            error_toast(this.$t("invalid file"));
          }
        }
        // x1.removeFiles().then(r => {
        //   console.log(r);
        // });
      }
    },
  },
  mounted() {},
  watch: {},
  updated: function() {},
};
</script>
